import { useCallback, useEffect, useState } from "react";
import { getInventoryVehicles } from "@/common/services/inventory-vehicles.api";
import { IInventory } from "@/types/inventory.types";
import { useCompanyStore } from "@/common/states/store/Company";

export const useGetInventories = () => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IInventory[]>([]);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const { filterMode, selectedCompanies, selectedUf } = useCompanyStore();

  const fetchInventories = useCallback(async (filters = {}) => {
    setLoading(true);
    setIsError(false);
    setError("");
    try {
      const inventories = await getInventoryVehicles(filters);
      if (inventories.ok && inventories) {
        setData(inventories.data);
        setTotalItems(inventories.totalItems);
      } else {
        setIsError(true);
        setError("Failed to fetch inventories");
      }
    } catch (error) {
      setIsError(true);
      setError("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchInventories();
  }, [fetchInventories, filterMode, selectedCompanies, selectedUf]);

  return {
    data,
    totalItems,
    isLoading,
    isError,
    error,
    refetch: fetchInventories,
  };
};
